import React from 'react';
import { Link } from 'react-router-dom';

import { associatedContactListShape } from '../../../prop-types';

export default function ContactListLink({ model: { id, name } }) {
  return <Link to={`/contacts/contact-lists/${id}/show`}>{name}</Link>;
}

ContactListLink.propTypes = {
  model: associatedContactListShape.isRequired,
};
